<!-- Start: Rejwan: 19-05-2025 GF Summary -->
<template>
    <div class="clearfix rounded mt-4 pb-5 mx-auto px-3">
        <b-card no-body>
            <b-overlay :show="showoverlay" rounded="sm">
                <div>
                    <div class="clearfix pl-0 col-md-12">
                        <div class="row justify-content-center pb-4 mt-3">
                           <h4> Gratuity Fund Scheme</h4>
                        </div>
                        <div class="row col-12 no-margin px-0">
                            <div class="col-md-12">
                                <div class="ibox-content pf-overview px-0 pb-0">
                                    <div class="payslip-details-info-inner row">
                                        <template >
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee ID</div>
                                                    <div class="second"> {{ gf_profile_data.employee_code }} </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee Name</div>
                                                    <div class="second"> {{ gf_profile_data.name }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Job Position</div>
                                                    <div class="second"> {{ gf_profile_data.jobposition }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Joining Date</div>
                                                    <div class="second"> {{ gf_profile_data.joining_date }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Leaving Date</div>
                                                    <div class="second"> {{ gf_profile_data.leaving_date }} </div>
                                                </div>
                                            </div>


                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Service Period</div>
                                                    <div class="second"> {{ gf_profile_data.service_period }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">GF Eligibility Period</div>
                                                    <div class="second">{{ gf_profile_data.eligibility_period }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Net GF Amount Payable</div>
                                                    
                                                    <div class="second">{{ formatMoney(gf_profile_data.payable_amount) }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">GF Amount Settled</div>
                                                    
                                                    <div class="second">{{ formatMoney(gf_profile_data.settled_amount) }}</div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
    </div>

</template>

<script>
export default{
    props: ['pageurl','employee_id','title','show'],
    data(){      
        return {
            dreg_show:1,
            showoverlay:false,
            gf_profile_data:[],
            is_gf_settlement: 1,
        }
    },
    methods:{
        gfDetailsNew: function(employee_id)
        { 
            if(employee_id>0)
            {
                let currentObj = this;
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_id', employee_id);
                formData.append('from', 'employee_panel'); 
                // formData.append('viewmode', 1);
                // formData.append('d_type', 'excel'); 
                axios.post(this.$api_url + '/gf/profile-overview', formData)
                .then(function (response) 
                {
                    if(response.data == false) {
                        this.is_gf_settlement = 0;
                    } else {
                        this.gf_profile_data = response.data;
                        this.showoverlay = false;
                        this.$bvModal.show('bv-modal-gf-overview');
                    }
                }.bind(this))
                .catch(function (error) 
                {
                }); 

            }
        },
    },
    created: function(){
          if(this.show > 0 && this.employee_id > 0)
          {
            this.gfDetailsNew(this.employee_id);
          }
    },
}
</script>
<!-- End: Rejwan: 19-05-2025 GF Summary -->